import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import ColataShell from '../../components/colata/ColataShell';
import ColataHomeContent from './components/ColataHomeContent';

// Pulsante evidenziato (colore del tema) verso il vecchio inventario CCO
const ExInventario = () => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate('/cco-home')}
      className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-primary text-primary-foreground hover:opacity-90 border border-primary transition-all group shadow-lg shadow-primary/20"
    >
      <Icon name="Archive" size={18} />
      <span className="text-[10px] font-black uppercase tracking-widest">Ex inventario</span>
    </button>
  );
};

// /colata-inventory — home del modulo Colata Continua (inventario per zone)
const ColataHomePage = () => (
  <ColataShell indietroA="/acv-home" azioniExtra={<ExInventario />}>
    <ColataHomeContent />
  </ColataShell>
);

export default ColataHomePage;
